import z from 'zod'

export const brandsNames = {
  DEFAULT: 'DEFAULT',
} as const

export const brandSchema = z.enum(Object.keys(brandsNames) as [keyof typeof brandsNames])

export default function getSchema() {
  const schema = z.object({
    brand: brandSchema,
    login: z.string({ message: 'Por favor, informe o usuário.' }).min(1, 'Por favor, informe o usuário.'),
    password: z.string({ message: 'Por favor, informe a senha.' }).min(1, 'Por favor, informe a senha.'),
  })

  return schema
}

// helpers
export function getAvaliableFieldByBrand(
  _brand: z.infer<typeof brandSchema>,
  schema: z.ZodObject<any>,
): string[] {
  return Object.keys(schema.shape).filter(key => key !== 'brand')
}
